import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseHttpService } from './base-http.service';
import { ConfigService } from './config.service';
import { AuthenticationService } from './authentication.service';

export interface FilterCondition {
  fieldKey: string;
  fieldLabel: string;
  fieldHash: string;
  values: string[];
}

export interface FilterGroup {
  id?: string;
  name: string;
  derivedFieldName: string;
  derivedFieldValue: string;
  description?: string;
  isActive: boolean;
  retroactiveFromDate?: string;
  conditionOperator: 'AND' | 'OR';
  conditions: FilterCondition[];
  createdAt?: string;
  updatedAt?: string;
  jobStatus?: 'pending' | 'running' | 'completed' | 'failed' | null;
  jobStartDate?: string | null;
  jobEndDate?: string | null;
  jobProgress?: number | null;
  jobEtaHours?: number | null;
  jobLog?: string | null;
}

@Injectable()
export class FilterGroupsService extends BaseHttpService {

  constructor(
    public http: HttpClient,
    public configService: ConfigService,
    public authenticationService: AuthenticationService
  ) {
    super(http);
  }

  getFilterGroups(): Observable<any> {
    return this.get('filter-groups');
  }

  getFilterGroup(id: string): Observable<any> {
    return this.get('filter-group', id);
  }

  createFilterGroup(payload: FilterGroup): Observable<any> {
    return this.post('filter-group', payload);
  }

  updateFilterGroup(id: string, payload: FilterGroup): Observable<any> {
    return this.put('filter-group', payload, id);
  }

  rerunFilterGroup(id: string): Observable<any> {
    return this.post(`filter-group/${id}/rerun`, {});
  }

}
